<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期间</label>
            <span class="weui-form-preview__value">{{initData.vm_yearmonth}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商</label>
            <span class="weui-form-preview__value">{{initData.ve_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期初余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vm_begin_es}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本期增加</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vm_add_es}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本期减少</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vm_reduce_es}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期末金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vm_end_es}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>